import React, { FC, Fragment, memo, useMemo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Dropdown } from '@ucheba/ui/components/Dropdown/desktop'
import { Menu, MenuItem } from '@ucheba/ui/components/Menu/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import {
  Table,
  TableBody,
  TableCol,
  TableHead,
  TableRow,
} from '@ucheba/ui/components/Table/desktop'
import { IInstitutionsRankingProps } from '../types'
import SC from '../base/InstitutionsRanking'
import { useInstitutionsRankingsLogic } from '../bll'
import { uz } from '../../../routs'
import { rankingHash } from '../constants'

const { Block, Logo, Institution } = SC

/** Советы по егэ */
const InstitutionsRanking: FC<IInstitutionsRankingProps> = (props) => {
  const { id, rating, year, ...otherProps } = props
  const { id: ratingId, name, description, subRatings, isLocal } = rating

  const {
    dropdownItems,
    isDropdownOpen,
    selectedSubRating,
    selectSubRating,
    rankingParticipants,
    isShowParticipants,
    toggleShowAllParticipants,
  } = useInstitutionsRankingsLogic(id, subRatings)

  const DropdownMenu = useMemo(
    () => (
      <Menu>
        {dropdownItems.map((subRating) => {
          return (
            <MenuItem key={subRating.id}>
              <Button
                color='blue'
                view='link'
                onClick={(): Promise<any> => selectSubRating(subRating)}
              >
                {subRating.name}
              </Button>
            </MenuItem>
          )
        })}
      </Menu>
    ),
    [dropdownItems, selectSubRating]
  )

  return (
    <Block id={`${rankingHash}-${ratingId}`} {...otherProps}>
      <Heading h2={`${name} – ${year}`} spacing='small' />

      <Text>{description}</Text>

      {rankingParticipants && rankingParticipants.participants.length > 0 && (
        <>
          <Spacing spacing='xlarge' />

          {dropdownItems.length > 1 ? (
            <Dropdown
              title={selectedSubRating.name}
              fontSize='h3'
              fontWeight='bold'
              menu={DropdownMenu}
              open={isDropdownOpen}
            />
          ) : (
            <Heading h3={selectedSubRating.name} />
          )}

          <Spacing spacing='small' />

          <Table>
            <TableHead>
              <TableRow>
                <TableCol>Вуз</TableCol>

                {!isLocal && (
                  <TableCol width='120px' textAlign='right'>
                    Место в мире
                  </TableCol>
                )}

                <TableCol width='120px' textAlign='right'>
                  Место в России
                </TableCol>
              </TableRow>
            </TableHead>

            <TableBody>
              {rankingParticipants.participants.map(
                ({ institution, worldRating, russianRating }, index) => (
                  <Fragment key={index}>
                    {(index < 3 || isShowParticipants) && (
                      <TableRow>
                        <TableCol>
                          <Institution href={`${uz.path}/${institution.id}`}>
                            <Logo
                              alt={institution.name}
                              fallbackUrl={institution?.logo?.fallbackUrl}
                              webpUrl={institution?.logo?.webp}
                            />

                            <Text>{institution.name}</Text>
                          </Institution>
                        </TableCol>

                        {!isLocal && <TableCol textAlign='right'>{worldRating}</TableCol>}

                        <TableCol textAlign='right'>{russianRating}</TableCol>
                      </TableRow>
                    )}
                  </Fragment>
                )
              )}
            </TableBody>
          </Table>

          {!isShowParticipants && rankingParticipants.participants.length > 3 && (
            <Button
              color='blue'
              view='outline'
              block
              onClick={(): void => toggleShowAllParticipants(true)}
            >
              Показать все
            </Button>
          )}
        </>
      )}
    </Block>
  )
}

export { InstitutionsRanking }
export default memo(InstitutionsRanking)
